/* @ngInject */
const format = () => {
  const self = {}

  self.user = (_movement) => {
    return _movement
  }
  self.server = (_movement) => {
    return _movement
  }

  return self
}

export default format



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/movement/services/format.service.js